<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Type" >
                                        <select class="form-control" size="large" v-model="inputType">
                                            <option v-for="option in typeOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row" v-if="site_type == 'ho'">
                                <div class="col-md-7">
                                    <base-input label="Location">
                                        <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Display onhand">
                                        <select class="form-control" size="large" v-model="inputDisplay">
                                            <option v-for="option in displayOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate Per Site
                            </base-checkbox>
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>        
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils, {dissectReportFilters} from '../../components/reportUtils';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import {
        mapState
    } from 'vuex'
import { getReportDescription } from '../../utilities';
    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'}
                ],
                inputType: '1',
                typeOptions: [
                    {key: '1', value: 'Weekly'},
                    {key: '2', value: 'Monthly'},
                    {key: '3', value: 'Quarterly'}
                ],
                inputDisplay: '1',
                displayOptions: [
                    {key: '1', value: 'All items regarless of onhand quantity'},
                    {key: '2', value: 'All items with onhand quantity only'},
                    {key: '3', value: 'All items with zero onhand quantity only'},
                    {key: '4', value: 'All items with negative onhand quantity only'},
                    {key: '5', value: 'All items with negative or zero onhand quantity'},
                    {key: '6', value: 'All items with positive or zero onhand quantity'},
                    {key: '6', value: 'All items except those with zero quantity'},
                ],

                currDate: moment().format("L_LT").split(":").join(";"),
                birSalesReports: [],
                showAdvancedInfo: 'asc',
                isSeparateSite: false,
                JsonData: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,
                reportDescription: '',
                inputLocation: [],
                locationOptions: []
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
        },
        computed: {
            ...mapState(['currentProfile','endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            costPerQty(cost, qty){
                if(Number(cost) > 0){
                    return Number(cost) / Number(qty)
                } else {
                    return 0
                } 
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            async onLocationChange(){
                var location = this.inputLocation[this.inputLocation.length - 1]
                if(!location){
                    this.handleClearInputLocation()
                }else {
                    this.siteOptions = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputSite = this.siteOptions.map( s => s.id);
                }
                
            },
            async handleClearInputLocation() {
                    var userId = secureStorage.getItem("userId");
                    var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                    let siteId = secureStorage.getItem("defaultSiteId");
                    this.inputSite = [siteId]
            },
            generateReport: async function () {
                this.spinning= true;
                let as_of = moment().format('MMMM DD, YYYY')
                let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "group": this.inputGroupBy,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "type": this.inputType,
                    "advanced_filter": this.params
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'inventory_aging_valuation?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    let header_top = [];
                    let header_detail = [];
                    
                    let header_text = "Week"
                    if(this.inputType == '2'){
                        header_text = "Month"
                    } else if(this.inputType == '3'){
                        header_text = "Quarter"
                    }
                    
                    header_top.push(
                        {content: 'Product\nCode', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Barcode', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Stock No.', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Description', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Retail\nPrice', rowSpan: 2, styles: {halign: 'center'}},
                        {content: `${header_text}`, colSpan: 4, styles: {halign: 'center'}},
                        {content: 'Sub Total', rowSpan: 2, styles: {halign: 'center'}},
                    )

                    header_detail.push(
                        {content: '1', styles: {halign: 'center'}},
                        {content: '2', styles: {halign: 'center'}},
                        {content: '3', styles: {halign: 'center'}},
                        {content: '3+', styles: {halign: 'center'}}
                    )

                    headers = [header_top, header_detail]

                    let grand_col1 = 0
                    let grand_col2 = 0
                    let grand_col3 = 0
                    let grand_col4 = 0

                    let assortment = 0

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_col1 = 0
                            let total_col2 = 0
                            let total_col3 = 0
                            let total_col4 = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                assortment = reportLine.product_count
                                
                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                
                                let subtotal = Number(reportLine.col_1) + Number(reportLine.col_2) + 
                                    Number(reportLine.col_3) + Number(reportLine.col_4)

                                let onhand = Number(reportLine.onhand_qty)
                                let rem = onhand

                                let cost_per_qty1 = this.costPerQty(reportLine.qty_x_cost1, reportLine.col_1)
                                let cost_per_qty2 = this.costPerQty(reportLine.qty_x_cost2, reportLine.col_2)
                                let cost_per_qty3 = this.costPerQty(reportLine.qty_x_cost3, reportLine.col_3)
                                let cost_per_qty4 = this.costPerQty(reportLine.qty_x_cost4, reportLine.col_4)

                                let col1_display = Number(reportLine.col_1)
                                let col2_display = Number(reportLine.col_2)
                                let col3_display = Number(reportLine.col_3)
                                let col4_display = Number(reportLine.col_4)
                                if(subtotal > rem){
                                    if(col1_display >= rem){
                                        col1_display = rem
                                        col2_display = 0
                                        col3_display = 0
                                        col4_display = 0
                                    } else {
                                        rem -= col1_display
                                        if(col2_display >= rem) {
                                            col2_display = rem
                                            col3_display = 0
                                            col4_display = 0
                                        } else {
                                            rem -= col2_display
                                            if(col3_display >= rem) {
                                                col3_display = rem
                                                col4_display = 0
                                            } else {
                                                rem -= col3_display
                                                col4_display = rem
                                            }
                                        }
                                    }
                                } else {
                                    let excess = rem - subtotal
                                    col4_display += excess
                                }

                                let cost_display1 = cost_per_qty1 * col1_display
                                let cost_display2 = cost_per_qty2 * col2_display
                                let cost_display3 = cost_per_qty3 * col3_display
                                let cost_display4 = cost_per_qty4 * col4_display

                                let subtotal_display = cost_display1 + cost_display2 + cost_display3 + cost_display4

                                total_col1 += cost_display1
                                total_col2 += cost_display2
                                total_col3 += cost_display3
                                total_col4 += cost_display4

                                grand_col1 += cost_display1
                                grand_col2 += cost_display2
                                grand_col3 += cost_display3
                                grand_col4 += cost_display4

                                let detail = []
                                detail.push(
                                    reportLine.product_id,
                                    reportLine.barcode,
                                    reportLine.stock_no,
                                    {content: reportLine.name, styles: {halign: 'left'}},
                                    this.convertToCurrency(Number(reportLine.retail_price)),
                                    this.convertToCurrency(cost_display1),
                                    this.convertToCurrency(cost_display2),
                                    this.convertToCurrency(cost_display3),
                                    this.convertToCurrency(cost_display4),
                                    this.convertToCurrency(subtotal_display)
                                )
                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    let total_detail = []

                                    let total_subtotal = total_col1 + total_col2 + total_col3 + total_col4
                                    let total_display = "Grand Total"
                                    if(this.isSeparateSite == true){
                                        total_display = "Site Sub Total"
                                    }

                                    if(this.isSeparateSite == false){
                                        total_detail.push(
                                            {content: `Assortment : ${assortment}`, styles: {halign: 'left'}}
                                        )
                                    } else {
                                        total_detail.push('')
                                    }

                                    total_detail.push(
                                        "", "", `${total_display} :`, "",
                                        this.convertToCurrency(total_col1), 
                                        this.convertToCurrency(total_col2), 
                                        this.convertToCurrency(total_col3), 
                                        this.convertToCurrency(total_col4), 
                                        this.convertToCurrency(total_subtotal)
                                    )

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, total_detail))
                                }
                            }
                        }

                        if(x == siteSpecific.length-1 && this.isSeparateSite == true){
                            let total_detail = []

                            let grand_subtotal = grand_col1 + grand_col2 + grand_col3 + grand_col4

                            total_detail.push(
                                {content: `Assortment : ${assortment}`, styles: {halign: 'left'}},
                                "", "", "Grand Total :", "",
                                this.convertToCurrency(grand_col1), 
                                this.convertToCurrency(grand_col2), 
                                this.convertToCurrency(grand_col3), 
                                this.convertToCurrency(grand_col4), 
                                this.convertToCurrency(grand_subtotal)
                            )

                            reportData.push(Object.assign({}, ["rowLine"]))
                            reportData.push(Object.assign({}, total_detail))
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + group_val
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Inventory Aging Valuation" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(15,25,"As of " + as_of)
                        if(this.isSeparateSite == true){
                            // doc.text(340,20,siteSpecific[x].report_details[0].site_name,"right");
                            doc.text(15, 30, `Site/s: ${siteSpecific[x].report_details[0].site_name}`)
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(15, 30, `Site/s: ${site_text}`)
                            // doc.text(340,20,site_text,"right");
                        }
                        let filterText = dissectReportFilters(parameters, this.displayOptions, this.formatOptions)
                        const {basic, advance} = filterText
                        doc.text(15, 35, `Filter/s: ${basic}`)
                        if (Object.keys(parameters.advanced_filter).length !== 0) {
                            doc.text(15, 40, `Product Filter/s: ${advance}`)
                        }

                        let colStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 30},
                            2: {cellWidth: 30},
                            3: {cellWidth: 55},
                            4: {cellWidth: 30},
                            5: {cellWidth: 30},
                            6: {cellWidth: 30},
                            7: {cellWidth: 30},
                            8: {cellWidth: 30},
                            9: {cellWidth: 30}
                        }

                        doc.autoTable({
                            // startY: 35, 
                            startY: Object.keys(this.params).length !== 0? 45 : 40,
                            head: headers, 
                            body: reportData, 
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            margin: {bottom: 25},
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[3] == 'Site Sub Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Inventory Aging Valuation" + group_text, 340, 200, i, pageCount)
                        }
                        
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Inventory_Aging_Valuation_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let as_of = moment().format('MMMM DD, YYYY')
                let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "group": this.inputGroupBy,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "type": this.inputType,
                    "advanced_filter": this.params
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'inventory_aging_valuation?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let site_specific = [];
                    let headers = [];
                    let header_top = [];
                    
                    let header_text = "Week"
                    if(this.inputType == '2'){
                        header_text = "Month"
                    } else if(this.inputType == '3'){
                        header_text = "Quarter"
                    }
                    
                    header_top.push('Product Code','Barcode','Stock No','Description','Retail\nPrice',`${header_text} 1`,`${header_text} 2`,`${header_text} 3`,`${header_text} 3+`,'Sub Total')

                    headers = header_top

                    let grand_col1 = 0
                    let grand_col2 = 0
                    let grand_col3 = 0
                    let grand_col4 = 0

                    let assortment = 0
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_col1 = 0
                            let total_col2 = 0
                            let total_col3 = 0
                            let total_col4 = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                assortment = reportLine.product_count
                                
                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                
                                let subtotal = Number(reportLine.col_1) + Number(reportLine.col_2) + 
                                    Number(reportLine.col_3) + Number(reportLine.col_4)

                                let onhand = Number(reportLine.onhand_qty)
                                let rem = onhand

                                let cost_per_qty1 = this.costPerQty(reportLine.qty_x_cost1, reportLine.col_1)
                                let cost_per_qty2 = this.costPerQty(reportLine.qty_x_cost2, reportLine.col_2)
                                let cost_per_qty3 = this.costPerQty(reportLine.qty_x_cost3, reportLine.col_3)
                                let cost_per_qty4 = this.costPerQty(reportLine.qty_x_cost4, reportLine.col_4)

                                let col1_display = Number(reportLine.col_1)
                                let col2_display = Number(reportLine.col_2)
                                let col3_display = Number(reportLine.col_3)
                                let col4_display = Number(reportLine.col_4)
                                if(subtotal > rem){
                                    if(col1_display >= rem){
                                        col1_display = rem
                                        col2_display = 0
                                        col3_display = 0
                                        col4_display = 0
                                    } else {
                                        rem -= col1_display
                                        if(col2_display >= rem) {
                                            col2_display = rem
                                            col3_display = 0
                                            col4_display = 0
                                        } else {
                                            rem -= col2_display
                                            if(col3_display >= rem) {
                                                col3_display = rem
                                                col4_display = 0
                                            } else {
                                                rem -= col3_display
                                                col4_display = rem
                                            }
                                        }
                                    }
                                } else {
                                    let excess = rem - subtotal
                                    col4_display += excess
                                }

                                let cost_display1 = cost_per_qty1 * col1_display
                                let cost_display2 = cost_per_qty2 * col2_display
                                let cost_display3 = cost_per_qty3 * col3_display
                                let cost_display4 = cost_per_qty4 * col4_display

                                let subtotal_display = cost_display1 + cost_display2 + cost_display3 + cost_display4

                                total_col1 += cost_display1
                                total_col2 += cost_display2
                                total_col3 += cost_display3
                                total_col4 += cost_display4

                                grand_col1 += cost_display1
                                grand_col2 += cost_display2
                                grand_col3 += cost_display3
                                grand_col4 += cost_display4

                                let detail = []
                                detail.push(
                                    reportLine.product_id,
                                    reportLine.barcode,
                                    reportLine.stock_no,reportLine.name,
                                    this.convertToCurrency(Number(reportLine.retail_price)),
                                    this.convertToCurrency(cost_display1),
                                    this.convertToCurrency(cost_display2),
                                    this.convertToCurrency(cost_display3),
                                    this.convertToCurrency(cost_display4),
                                    this.convertToCurrency(subtotal_display)
                                )
                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    let total_detail = []

                                    let total_subtotal = total_col1 + total_col2 + total_col3 + total_col4
                                    let total_display = "Grand Total"
                                    if(this.isSeparateSite == true){
                                        total_display = "Site Sub Total"
                                    }

                                    if(this.isSeparateSite == false){
                                        total_detail.push(`Assortment : ${assortment}`)
                                    } else {
                                        total_detail.push('')
                                    }

                                    total_detail.push(
                                        "", "", `${total_display} :`, "",
                                        this.convertToCurrency(total_col1), 
                                        this.convertToCurrency(total_col2), 
                                        this.convertToCurrency(total_col3), 
                                        this.convertToCurrency(total_col4), 
                                        this.convertToCurrency(total_subtotal)
                                    )

                                    reportData.push(Object.assign({}, total_detail))
                                }
                            }
                        }

                        if(x == siteSpecific.length-1 && this.isSeparateSite == true){
                            let total_detail = []

                            let grand_subtotal = grand_col1 + grand_col2 + grand_col3 + grand_col4

                            total_detail.push(`Assortment : ${assortment}`,
                                "", "", "Grand Total :", "",
                                this.convertToCurrency(grand_col1), 
                                this.convertToCurrency(grand_col2), 
                                this.convertToCurrency(grand_col3), 
                                this.convertToCurrency(grand_col4), 
                                this.convertToCurrency(grand_subtotal)
                            )

                            reportData.push(Object.assign({}, total_detail))
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + group_val
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Inventory Aging Valuation" + group_text, "Generate By: " + printed_by,"As of " + as_of])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                        // this.JsonData = site_specific;
                    }
                        // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>